import { T_PRIVACY_POLICY_PAGE_CONSTANTS } from './TYPES'

const DE_PRIVACY_POLICY_PAGE_CONSTANTS: T_PRIVACY_POLICY_PAGE_CONSTANTS = {
  PAGE_KICKER: 'GRIFFYREADS',
  PAGE_TITLE: 'Datenschutzerklärung',
  PAGE_CONTENT: [
    {
      TITLE: 'Einleitung',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'ADONIS CONSULTANCY informiert als Inhaber und Betreiber der Website www.griffyreads.com sowie der entsprechenden Anwendung GriffyReads („die App“) Besucher und registrierte Nutzer über ihre Datenverarbeitungspraktiken, die geeigneten technischen und organisatorischen Maßnahmen zum Schutz personenbezogener Daten sowie über die den Nutzern zur Verfügung stehenden Rechtsbehelfe.',
            'Diese Datenschutzerklärung erläutert, wie Ihre personenbezogenen Daten erhoben, verwendet und geschützt werden.',
            'Durch die Registrierung für die Anwendung und die Erstellung eines Kontos erteilen volljährige Nutzer ihre ausdrückliche Einwilligung zur Verarbeitung ihrer personenbezogenen Daten sowie – soweit zutreffend – zur Verarbeitung der personenbezogenen Daten eines Kindes, für das Sie ein Konto (verknüpftes Konto) einrichten, gemäß dieser Datenschutzerklärung.'
          ]
        }
      ]
    },
    {
      TITLE: 'Der Datenverantwortliche',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Der Datenverantwortliche ist ADONIS CONSULTANCY (Sitz: Belgien, 1170 Watermael-Boitsfort, 16 avenue de l’Hermine), Steuernummer: BE 0553 528 124, vertreten durch den Gründer Ralph EL KHOURY) („der Verantwortliche“).',
            'Alle personenbezogenen Daten, die über die Dienste des Verantwortlichen erhoben werden, werden sicher auf Servern gespeichert und verarbeitet, die von Amazon Web Services (AWS) in der Region Europa (Irland) (eu-west-1) gehostet werden. Dementsprechend werden sämtliche personenbezogenen Daten innerhalb des Europäischen Wirtschaftsraums (EWR) gespeichert und unterliegen den Datenschutzvorschriften der Europäischen Union, einschließlich der Verordnung (EU) 2016/679 des Europäischen Parlaments und des Rates vom 27. April 2016 zum Schutz natürlicher Personen bei der Verarbeitung personenbezogener Daten und zum freien Datenverkehr („DSGVO“).'
          ]
        }
      ]
    },
    {
      TITLE:
        'Die vom Verantwortlichen verarbeiteten Daten und die Ziele der Datenverarbeitung',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'a)	Die zum Zeitpunkt der Registrierung mitgeteilten Informationen:',
            'Nur Erwachsenen ist es gestattet, die Kontoerstellung durch Registrierung für die App zu initiieren. Bei der Registrierung müssen erwachsene Nutzer ihren vollständigen Namen, ihr Geburtsdatum, ihre Sprachpräferenz, ihre E-mail-adresse, ihr Passwort und einen Benutzernamen angeben. Sobald ihr Konto erstellt ist, können Erwachsene verknüpfte Konten für ihre Kinder oder Schüler erstellen, indem sie die gleichen Informationen bereitstellen. Nach der Erstellung des Kinderkontos kann sich das Kind selbstständig einloggen und auf die App zugreifen.',
            ' ',
            ' ',
            'Zweck der Datenverwendung:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Bereitstellung des Zugangs zur App und Ermöglichung der Anmeldung',
            'Verwaltung und Betrieb von Nutzerkonten',
            'Personalisierung der Nutzererfahrung, einschließlich Charakterentwicklung und Ranglisten'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Rechtsgrundlage:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Artikel 6 Absatz 1 Buchstabe b DSGVO – Vertrag: Die Verarbeitung ist für die Erfüllung eines Vertrages (Bereitstellung des Zugriffs auf und der Nutzung der App) erforderlich.',
            'Art. 6 Abs. 1 Buchst. f DSGVO – berechtigtes Interesse des Verantwortlichen: Um das ordnungsgemäße Funktionieren der Benutzerkonten zu gewährleisten und Missbrauch zu verhindern.',
            'In Bezug auf personenbezogene Daten von Kindern unter 13 Jahren ist gemäß Artikel 8 der DSGVO und belgischem Recht die Zustimmung der Eltern erforderlich. Dies wird dadurch sichergestellt, dass nur ein Erwachsener ein Konto für ein Kind in der App erstellen darf und dass der Erwachsene die erforderlichen personenbezogenen Daten im Namen des Kindes zur Verfügung stellt.'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'b)	Daten im Zusammenhang mit Quizzen: ',
            ' ',
            'Um das Leseverständnis eines Buches zu testen, laden erwachsene Nutzer Quizzen hoch, die aus Multiple-Choice-Fragen bestehen. Nach Genehmigung durch einen Administrator werden Quizfragen in der App gespeichert und stehen allen Nutzern zur Verfügung. Die App speichert Informationen über die Ergebnisse eines Abenteurers, einschließlich der gesammelten Punkte und des Fortschritts.',
            ' ',
            ' ',
            'Zweck der Datenverwendung:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Bereitstellung der Kernfunktionen der App (Quiz und Fortschrittsverfolgung)',
            'Unterstützung der Bildungs- und Interaktionsziele'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Rechtsgrundlage:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Artikel 6 Absatz 1 Buchstabe b DSGVO – Vertrag: Zur Bereitstellung der Kernfunktionalität der App (Quiz und Fortschrittsverfolgung). ',
            'Art. 6 Abs. 1 Buchst. f DSGVO – berechtigtes Interesse des Verantwortlichen: Zur Unterstützung der pädagogischen und interaktiven Zwecke der App.'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'c)	Daten zu besessenen Büchern:',
            ' ',
            'Die App speichert Identifikationsdaten zu den Büchern, die Kinder in ihrer Bibliothek angeben, und ermöglicht deren Austausch unter Kindern. Dadurch wird die Nachhaltigkeit gefördert, indem das Ausleihen von Büchern anstelle des Neukaufs unterstützt wird.',
            ' ',
            ' ',
            'Zweck der Datenverwendung:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Bereitstellung der virtuellen Bibliotheksfunktion',
            'Ermöglichung des Buchtausches und Förderung der Ausleihe'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Rechtsgrundlage:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Artikel 6 Absatz 1 Buchstabe b DSGVO – Vertrag: Um die Bibliothek und den Buchaustausch anbieten zu können.',
            'Art. 6 Abs. 1 Buchst. f DSGVO – berechtigtes Interesse des Verantwortlichen: Förderung von Nachhaltigkeit und sozialer Interaktion durch das Teilen von Büchern.'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'd)	Kommunikationsdaten:',
            ' ',
            'Der Verantwortliche sammelt Informationen aus E-Mails und Push-Benachrichtigungen, die zu statistischen Zwecken gesendet werden.',
            ' ',
            ' ',
            'Zweck der Datenverwendung:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Versand von App-bezogenen Updates, Eventsinformationen und Mitteilungen zu Wettbewerben',
            'Analyse der Kommunikationswirksamkeit und Verbesserung der App'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Rechtsgrundlage:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Art. 6 Abs. 1 Buchst. f DSGVO – berechtigtes Interesse des Verantwortlichen: Zur Analyse der Kommunikationseffektivität und Verbesserung der App.'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'e)	Zahlungsinformationen:',
            ' ',
            'Die Bezahlung von Abonnements erfolgt über PayPal. Zahlungsdaten werden von der Plattform des Verantwortlichen nicht gespeichert.'
          ]
        }
      ]
    },
    {
      TITLE: 'Weitergabe Ihrer personenbezogenen Daten',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Der Verantwortliche verkauft, handelt oder übermittelt Ihre personenbezogenen Daten nicht an Dritte, es sei denn, dies ist erforderlich, um die Dienste der App bereitzustellen, die geltenden gesetzlichen Anforderungen zu erfüllen oder seine Rechte zu schützen.'
          ]
        }
      ]
    },
    {
      TITLE: 'Datensicherheit',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Der Verantwortliche ergreift geeignete Sicherheitsmaßnahmen, um Ihre personenbezogenen Daten vor unbefugtem Zugriff, Änderung, Offenlegung oder Zerstörung zu schützen.'
          ]
        }
      ]
    },
    {
      TITLE: 'Ihre Rechte',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Sie haben das Recht, vom Verantwortlichen Zugang zu Ihren personenbezogenen Daten sowie deren Berichtigung oder Löschung zu verlangen. Sie können der Verarbeitung Ihrer Daten auch widersprechen oder diese einschränken. Um diese Rechte auszuüben, wenden Sie sich bitte an den Verantwortlichen unter contact@griffyreads.com.'
          ]
        }
      ]
    },
    {
      TITLE: 'Änderungen an dieser Datenschutzerklärung',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Der Verantwortliche kann diese Datenschutzerklärung von Zeit zu Zeit aktualisieren. Der Verantwortliche wird Sie über alle Änderungen informieren, indem er die neue Richtlinie auf seiner Website veröffentlicht. Ihre fortgesetzte Nutzung der App nach solchen Änderungen bedeutet, dass Sie die neue Datenschutzerklärung akzeptieren.'
          ]
        }
      ]
    },
    {
      TITLE: 'Kontaktieren Sie uns',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Wenn Sie Fragen oder Bedenken zu dieser Datenschutzerklärung haben, wenden Sie sich bitte an den Verantwortlichen unter contact@griffyreads.com.'
          ]
        }
      ]
    },
    {
      TITLE: 'Recht auf Beschwerde',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen geltende Datenschutzgesetze verstößt, haben Sie das Recht, eine Beschwerde bei einer Aufsichtsbehörde einzureichen.',
            '',
            '',
            'In Belgien ist die zuständige Behörde:',
            'Belgische Datenschutzbehörde',
            'Rue de la Presse 35, 1000 Brüssel',
            '',
            '',
            'Website: https://www.dataprotectionauthority.be',
            '',
            '',
            '',
            'Diese Datenschutzerklärung gilt ab dem 05 Mai 2025.'
          ]
        }
      ]
    }
  ]
}

export default DE_PRIVACY_POLICY_PAGE_CONSTANTS
